import FlightInfoCard from "./FlightInfoCard";

export default FlightInfoCard;
